import { ClassFlag } from "../../../library-js/dom-tools/ClassFlag";
import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";
import { UserLoginStatusResponse } from "../../../library-js/php/user/UserLoginStatusRequest";
import { Rokojori } from "../Rokojori";

export class UserLoginStatus
{
  static readonly attribute = new ElementAttribute( "user-login-status" );

  static _elements:HTMLElement[];
  static _initialized = false;

  static applyOnDocument()
  {
    UserLoginStatus.initialize();

    this._elements = [];
    UserLoginStatus.attribute.forEachInDoc( e => this._elements.push( e as HTMLElement ) );

    UserLoginStatus.updateStatus();
  }

  static initialize()
  {
    if ( this._initialized )
    {
      return;
    }

    this._initialized = true;
    Rokojori.$.userSystem.userID.addListener( ()=> UserLoginStatus.updateStatus() );
    
  }

  static updateStatus()
  {
    console.log( "Updating status: is logged in", Rokojori.$.userSystem.isLoggedIn );
    UserLoginStatus._elements.forEach( e => this.setStatus( e ) )
  }

  static setStatus( e:Element )
  {
    let hasUser = Rokojori.$.userSystem.isLoggedIn;
    let value = hasUser ? "logged-in" : "no-user";

    UserLoginStatus.attribute.to( e, value );
  }
}